import React, { useMemo, useState } from "react";
import DefaultLayout from "../../../layouts/DefaultLayout";
import {
  Link,
  useNavigate,
  // useParams
} from "react-router-dom";
import Path from "../../../route/Path";
// import InputField from "../../../components/commonUI/InputField";
import MainContentLayout from "../../../layouts/MainContentLayout";
// import CommonDialog from "../../../components/CommonDialog";
import { createContact } from "../../../services/api/1C";
import { toast } from "react-toastify";
import CreateCompleteDialog from "../../../components/CommonDialog/CreateCompleteDialog";
import GA, { EVENT_NAMES } from "../../../services/googleAnalytics";
function ContactingOperator() {
  const navigate = useNavigate();
  const [contact, setContact] = useState({
    title: "",
    content: "",
  });

  const [contactConfirmed, setContactConfirmed] = useState(null);
  const [sendContactStatus, setSendContactStatus] = useState("idle");

  const isValidContact = useMemo(
    () =>
      contact.title &&
      contact.content &&
      contact.title.trim() &&
      contact.content.trim(),
    [contact]
  );

  const handleSendContact = () => {
    if (!contact || sendContactStatus === "loading") return;
    setSendContactStatus("loading");

    createContact(contactConfirmed)
      .then((res) => {
        GA.tracking(EVENT_NAMES.CONTACT_US.SUBMIT, {
          salonId: res.data._id,
        });
        setSendContactStatus("success");
      })
      .catch((error) => {
        toast.error("Send consultation error!");
        console.log("error: ", error);
        setSendContactStatus("idle");
      });
  };

  return (
    <DefaultLayout>
      <MainContentLayout
        pageTitle={
          <>
            <p>予約</p>
          </>
        }
      >
        <div className="w-full h-full pt-16 pb-8 lg:py-12 relative">
          <div className="w-full h-16 lg:h-12 pl-20 lg:pl-0 flex items-center justify-start absolute inset-x-0 top-0 bg-[#F0F1EF] bg-opacity-50">
            <h2 className="text-base lg:text-xl font-semibold">
              頭皮ラボ運営へ連絡
            </h2>
          </div>

          <div className="w-full h-full py-3">
            <div className="w-full h-full border border-gray-400 p-6 rounded-xl">
              <div className="w-full h-auto flex items-center mb-6">
                <label
                  className="w-20 h-10 flex items-center font-semibold"
                  htmlFor="title"
                >
                  タイトル
                </label>
                <div className="w-[calc(100%-80px)] h-10">
                  <input
                    id="title"
                    type="text"
                    value={contact.title}
                    onChange={(e) =>
                      setContact((oldState) => ({
                        ...oldState,
                        title: e.target.value,
                      }))
                    }
                    readOnly={contactConfirmed}
                    className={`w-full h-full px-3 py-2 text-base border border-gray-400 rounded-md ${
                      contactConfirmed ? "bg-gray-100" : ""
                    }`}
                  />
                </div>
              </div>

              <div className="w-full h-[calc(100%-64px)] flex items-start">
                <label
                  className="w-20 h-10 flex items-center font-semibold"
                  htmlFor="content"
                >
                  本文
                </label>
                <div className="w-[calc(100%-80px)] h-full">
                  <textarea
                    id="content"
                    type="text"
                    value={contact.content}
                    onChange={(e) =>
                      setContact((oldState) => ({
                        ...oldState,
                        content: e.target.value,
                      }))
                    }
                    readOnly={contactConfirmed}
                    className={`w-full h-full px-3 py-2 text-base border border-gray-400 rounded-md ${
                      contactConfirmed ? "bg-gray-100" : ""
                    }`}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="w-full h-8 flex items-center justify-end text-white text-base font-semibold absolute inset-x-0 bottom-0">
            {!contactConfirmed ? (
              <>
                <Link
                  to={-1}
                  className="button-size bg-gray-btn-secondary mr-4"
                >
                  戻る
                </Link>

                <button
                  onClick={() => {
                    if (isValidContact) setContactConfirmed(contact);
                  }}
                  type="button"
                  className={`button-size ${
                    isValidContact
                      ? "bg-blue-btn-primary"
                      : "bg-gray-btn-secondary"
                  }`}
                >
                  内容確認
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={() => setContactConfirmed(null)}
                  type="button"
                  className="button-size bg-gray-btn-secondary mr-4 lg:mr-6"
                >
                  戻る
                </button>

                <button
                  onClick={handleSendContact}
                  type="button"
                  className="button-size bg-blue-btn-primary"
                >
                  登録
                </button>
              </>
            )}
          </div>
        </div>

        <CreateCompleteDialog
          open={sendContactStatus === "success"}
          createCompleteTitle="頭皮ラボ運営へ連絡しました"
          createCompleteBtnLabel2="終了"
          createCompleteAction2={() => {
            // navigate(-1);
            navigate(Path.scalpLabManagement);
          }}
        />
      </MainContentLayout>
    </DefaultLayout>
  );
}

export default ContactingOperator;
